import React from "react";
import { Button, FormControlLabel, Switch } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SearchAndStatusFilter from "../../../components/SearchAndStatusFilter";
import { Pagination } from "../../../components/pagination/Pagination";
import { ToastContainer, toast } from "react-toastify";
import { Spinner } from "../../../components/Spinner/Spinner";
import Modal from "../../../components/Modal";
import Table from "../../../components/Table/Table";
import useOpeningStock from "./hooks/useOpeningStock";
import useReduxStore from "../../../hooks/useReduxStore";

const OpeningStock = () => {
  const navigate = useNavigate();
  const { selector: user } = useReduxStore("auth");
  const { data, methods } = useOpeningStock();
  const { inventoryList, totalCount, controller, filter } = data;
  const {
    handlePagination,
    inventoryDelete,
    handleToggleChange,
    handleSearchChange,
    handleStatusChange,
    handleApplyFilter,
    handleResetFilter,
  } = methods;

  const TableHead = [
    { label: "#", id: "" },
    { label: "Product Name", id: "" },
    { label: "Category", id: "" },
    { label: "Vendor", id: "" },
    { label: "Price", id: "" },
    { label: "Purchase Price", id: "" },
    { label: "Units", id: "" },
    { label: "Minimum Stock Level", id: "" },
    { label: "Quantity", id: "" },
    { label: "Status", id: "" },
    { label: "Action", id: "" },
  ];

  const handleEdit = (inventoryItem) => {
    navigate(`/setting/opening-stock/edit/${inventoryItem._id}`, {
      state: { inventoryData: inventoryItem },
    });
  };

  console.log( user?.userInfo?.permission?.inventory
                                  ?.edit?.value,'555555555555555555555555555')

  return (
    <>
      {/* {isLoading && <Spinner />} */}
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="row">
          <div className="d-flex justify-content-between align-items-end">
            <div className="d-flex">
              {/* <SearchAndStatusFilter /> */}
              <SearchAndStatusFilter
                search={filter.search}
                statusType={filter.isDeleted}
                onSearchChange={handleSearchChange}
                setStatusType={handleStatusChange}
                applayFilter={handleApplyFilter}
                reset={handleResetFilter}
              />
            </div>
            <div className="d-flex">
              {user?.userInfo?.permission?.inventory?.add?.value && (
                <Button
                  onClick={() => navigate(`/setting/opening-stock/add`)}
                  className="dropDownButtons11"
                  startIcon={<AddIcon />}
                >
                  Add New
                </Button>
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-12 ticet">
          <div className="bg shadow raduus">
            {/* <div className=""> */}
            <div className="mt-4">
              <table className="table">
                <Table TableHeadData={TableHead} />
                <tbody className="mt-3">
                  {inventoryList?.map((item, index) => {
                    return (
                      <tr
                        // className="text-start rounded-row "
                          className={item.isDeleted ? 'table-active text-start rounded-row tablebess border-top-0 border-start-0 border-end-0 border-light' : `text-start rounded-row tablebess `}
                        style={{
                          borderRadius: "50px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <td className="table-link">
                          {controller.rowsPerPage * (controller.page - 1) +
                            index +
                            1}{" "}
                        </td>
                        <td className="">{item?.productName}</td>
                        <td className="">{item?.category?.name}</td>
                        <td className="">{item?.vendor?.name}</td>
                        <td className="">{item?.price}</td>
                        <td className="">{item?.purchasePrice}</td>
                        <td className="">{item?.units}</td>
                        <td className="">{item?.minimumQuantityLevel}</td>
                        <td className="">{item?.quantity}</td>
                        <td className="">
                          <FormControlLabel
                            control={
                              <Switch disabled={item?.isDeleted }
                                checked={item?.isActive}
                                onChange={() =>
                                  handleToggleChange(item._id, item.isActive)
                                }
                              />
                            }
                          />
                        </td>
                        <td>
                          <div className="dropdown p-0 align-items-center justify-content-center">
                            <i
                              className="fas fa-ellipsis-v pointer p-2"
                              id="dropdownMenuLink"
                               data-bs-toggle={
                                user?.userInfo?.permission?.inventory?.edit?.value ? "dropdown" : ""
                                }
                              aria-expanded="false"
                              style={{
                                cursor: user?.userInfo?.permission?.inventory
                                  ?.edit?.value
                                  ? "pointer"
                                  : "not-allowed",
                                  //  pointerEvents: item.isDeleted ? "none" : "auto",
                              }}
                            />
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuLink"
                            >
                              {item.isDeleted ? '' : <li
                                onClick={() => handleEdit(item)}
                                style={{ cursor: "pointer" }}
                                className="dropdown-item"
                              >
                                Edit
                              </li>}
 
                              <li
                                className="dropdown-item"
                                style={{ cursor: "pointer" }}
                                 onClick={() => inventoryDelete(item._id, item.isDeleted)}
                              >
                                {item.isDeleted ? 'Recover' :'Delete'}
                             
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {!inventoryList?.length && (
                <div className="text-center">No record found</div>
              )}
              <Pagination
                count={totalCount}
                controller={controller}
                setController={handlePagination}
              />
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>

      {/* Delete Modal */}
      {/* <Modal
        size="md"
        show={deleteModal.open}
        onHide={() => setDeleteModal((prev) => ({ ...prev, open: false }))}
        headerContent={<h5>Delete?</h5>}
        bodyContent={
          <div className="">
            <p>Are you sure you want to delete? </p>
            <div className="d-flex justify-content-end mt-4">
              <Button variant="contained" onClick={handleDelete}>
                Yes
              </Button>
              <Button variant="outlined" className="ms-2" onClick={() => setDeleteModal((prev) => ({ ...prev, open: false }))} data-bs-dismiss="modal">
                No
              </Button>
            </div>
          </div>
        }
      /> */}
    </>
  );
};

export default OpeningStock;
